import { contentApi } from '../../api/content';
import type { LearningItemView } from '../../api/content.types';
import type { FlashcardMode } from './types';

/**
 * Lấy đúng bộ item của 1 Bài theo mode đang chọn ở thư viện flashcard — DÙNG CHUNG cho
 * màn danh sách và màn flashcard để hai màn luôn khớp nhau.
 */
export async function fetchLessonItemsForMode(unitId: string, mode: FlashcardMode): Promise<LearningItemView[]> {
  if (mode === 'kanji') return contentApi.getUnitKanji(unitId);

  // Kanji không nằm trong Lesson nên có API riêng ở nhánh trên; vocab/grammar vẫn đọc qua Lesson.
  const track = mode === 'vocab' ? 'VOCAB' : 'GRAMMAR';
  const unit = await contentApi.getUnit(unitId);
  const lessons = unit.lessons.filter((l) => l.mode === 'STANDARD' && l.track === track);
  const details = await Promise.all(lessons.map((l) => contentApi.getLesson(l.id)));
  return details.flatMap((l) => l.items);
}
